
import { Component, Vue } from "vue-property-decorator";

import { API_ROUTES } from "@/utils/API";
import { API_TReport } from "@/models/report";
import { SMUser } from "@/store";

const REPORT_PARSE_TYPE = "html";

const ICONS = {
  alert: "alert-circle-outline",
};

const TRUE_AS_STRING = "true";

const NOT_GENERATED_ERROR = "not_generated";

@Component({
  components: {
    Loader: () => import("@/components/Loader/Loader.vue"),
    NotificationTemplate: () =>
      import("@/components/NotificationTemplate/NotificationTemplate.vue"),
    NotificationDataNotLoaded: () =>
      import("@/components/Notifications/NotificationDataNotLoaded.vue"),
    CoverLetter: () => import("@/components/CoverLetter/CoverLetter.vue"),
  },
})
export default class VExpertTemplateCoverLetter extends Vue {
  notes = false; // NOTE: Bind with "Advisor"

  loading = false;
  error = false;
  notGenerated = false;

  icons = ICONS;

  src: API_TReport = {
    content: "",
    eligibility_result: "",
    user_name: "",
    widget_type: "",
    has_child_case: false,
    is_sl_started: false,
    if_sponsor: false,
  };

  get covertLetterProps() {
    const { src, serviceId, alias, isEditable } = this;

    return { src, serviceId, alias, isEditable };
  }

  get serviceId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  get user() {
    return SMUser.user;
  }

  get alias(): string {
    const { query, params } = this.$route;

    return (query?.report_template_alias || params?.report_template_alias || "") as string;
  }

  get isEditable(): boolean {
    const { isEditable } = this.$attrs;

    return typeof isEditable === "boolean" ? isEditable : isEditable === TRUE_AS_STRING;
  }

  async fetch() {
    try {
      this.loading = true;
      this.error = false;
      this.notGenerated = false;

      const { serviceId, user } = this;

      if (!serviceId || !user) return;

      const { data } = await this.$http.get(
        API_ROUTES.CASE_REPORT_PARSE(serviceId, this.alias, REPORT_PARSE_TYPE)
      );

      if (data?.Message === NOT_GENERATED_ERROR) this.notGenerated = true;

      if (!data) return;

      this.src = { ...data };
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  update(payload: string) {
    this.src.content = payload;
  }

  mounted() {
    // NOTE: DEV-1860. Here better to use "mounted" hook to protect missing unsaved data changes in editor;
    this.fetch();
  }
}
